/**
 * Scrolls a child element into view within its scrollable parent container,
 * only if it's not already fully visible. This avoids scrolling the entire page
 * and keeps the scroll behavior scoped to the specified parent.
 *
 * @param childEl - The child element to scroll into view.
 * @param parentEl - The scrollable parent container element.
 */
export function scrollChildIntoView(childEl: HTMLElement, parentEl: HTMLElement) {
    const offsetTop = childEl.offsetTop - parentEl.offsetTop;
    const offsetBottom = offsetTop + childEl.offsetHeight;

    const parentScrollTop = parentEl.scrollTop;
    const parentHeight = parentEl.clientHeight;

    if (offsetTop < parentScrollTop) {
        // eslint-disable-next-line no-param-reassign
        parentEl.scrollTop = offsetTop; // scroll up
    } else if (offsetBottom > parentScrollTop + parentHeight) {
        // eslint-disable-next-line no-param-reassign
        parentEl.scrollTop = offsetBottom - parentHeight; // scroll down
    }
}
